import React from 'react'
import { useQueryParams, StringParam, ArrayParam } from 'use-query-params'
import styled from 'styled-components'
import { SchoolHelper } from '@laputan/helpers'
import { SchoolSearchResult } from '../../containers/SchoolSearchResult'
import { Layout } from '../../containers/Layout'
import { STYLES } from '../../static/style'
import { AroundSchoolsSEO } from '../../containers/Page/AroundSchoolsSEO'

const StyledSchoolsPage = styled(Layout)``

const SchoolsPage = ({ location }: { location: any }) => {
  const [{ search, levels, gender, sector }] = useQueryParams({
    search: StringParam,
    levels: ArrayParam,
    gender: StringParam,
    sector: StringParam,
  })
  return (
    <StyledSchoolsPage
      pathname={location.pathname}
      contentStyle={{
        backgroundColor: STYLES.COLOR_ATHENS_GRAY,
      }}
    >
      <AroundSchoolsSEO
        title={SchoolHelper.getSearchPageTitleText(search, {
          levels,
          gender,
          sector,
        })}
        pathname={`${location.pathname}${location.search}`}
      />
      <SchoolSearchResult />
    </StyledSchoolsPage>
  )
}

export default SchoolsPage
